export const DEAL_COMMENTS_NAMESPACE = 'deal-central-deal';

export const SHOW_DEAL_MESSAGES_KEY = 'showDealMessages';

export const DEAL_COMMENTS_NR_ACTIONS = {
    scriptLoaded: 'contextualCommentsScriptLoaded',
    scriptFailed: 'contextualCommentsScriptFailed',
    missingIdentity: 'contextualCommentsMissingIdentity',
    updated: 'contextualCommentsUpdated'
} as const;
